import { useState } from "react";

export const PriceInput = ({ paymentData, setPaymentData }) => {
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    paymentData.payment_type
  );
  const [selectedPlans, setSelectedPlans] = useState({
    monthly: true,
    quarterly: Boolean(paymentData?.subscription_plans?.quarterly),
  });

  const handlePaymentTypeChange = (e) => {
    if (e.target.value === "one-time") {
      setPaymentData((prev) => ({
        ...prev,
        payment_type: e.target.value,
        subscription_plans: null,
      }));
    } else {
      setPaymentData((prev) => ({ ...prev, payment_type: e.target.value }));
    }
    setSelectedPaymentType(e.target.value);
  };

  const handlePlanChange = (plan, value) => {
    setSelectedPlans((prev) => ({
      ...prev,
      [plan]: value,
    }));

    if (!value) {
      setPaymentData((prev) => ({
        ...prev,
        subscription_plans: {
          ...prev.subscription_plans,
          [plan]: null,
        },
      }));
    }
  };

  const updateSubscriptionPlan = (plan, field, value) => {
    setPaymentData((prev) => {
      const prevSubPlans = prev.subscription_plans;

      return {
        ...prev,
        subscription_plans: {
          ...prevSubPlans,
          [plan]: prevSubPlans
            ? {
                ...prevSubPlans[plan],
                [field]: value,
              }
            : {
                [field]: value,
              },
        },
      };
    });
  };

  const getMinDate = () => {
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const formattedTomorrow = tomorrow.toISOString().slice(0, 16);

    return formattedTomorrow;
  };

  return (
    <div className="space-y-6">
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Payment Type
        </label>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="radio"
              value="one-time"
              checked={selectedPaymentType === "one-time"}
              onChange={handlePaymentTypeChange}
              className="mr-2"
            />
            <span>One-time Payment</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              value="subscription"
              checked={selectedPaymentType === "subscription"}
              onChange={handlePaymentTypeChange}
              className="mr-2"
            />
            <span>Subscription</span>
          </label>
        </div>
      </div>

      {selectedPaymentType === "one-time" && (
        <div className="mb-4">
          <label
            htmlFor="one-time-price"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            One-time Price
          </label>
          <input
            type="number"
            id="one-time-price"
            min={0}
            value={paymentData.price}
            onChange={(e) =>
              setPaymentData({
                ...paymentData,
                price: parseFloat(e.target.value),
              })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
          />
        </div>
      )}

      {selectedPaymentType === "subscription" && (
        <>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Dose Type
            </label>
            <div className="space-y-2">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="true"
                  checked={
                    paymentData.subscription_plans?.is_dose_static === "true"
                  }
                  onChange={(e) => {
                    setPaymentData({
                      ...paymentData,
                      subscription_plans: {
                        ...paymentData.subscription_plans,
                        is_dose_static: e.target.value,
                      },
                    });
                    handlePlanChange("quarterly", false);
                  }}
                  className="mr-2"
                />
                <span>Static Dose</span>
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="false"
                  checked={
                    paymentData.subscription_plans?.is_dose_static !== "true"
                  }
                  onChange={(e) => {
                    setPaymentData({
                      ...paymentData,
                      subscription_plans: {
                        ...paymentData.subscription_plans,
                        is_dose_static: e.target.value,
                      },
                    });
                  }}
                  className="mr-2"
                />
                <span>Variable Dose</span>
              </label>
            </div>
          </div>

          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Subscription Plans
            </label>
            <div className="space-y-2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedPlans.monthly}
                  className="mr-2"
                  readOnly={true}
                />
                <span>Monthly</span>
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={selectedPlans.quarterly}
                  onChange={() =>
                    handlePlanChange(
                      "quarterly",
                      !Boolean(selectedPlans.quarterly)
                    )
                  }
                  className="mr-2"
                />
                <span>Quarterly</span>
              </label>
            </div>
          </div> */}

          {selectedPlans.monthly && (
            <div className="mb-6 p-4 border border-gray-200 rounded-md">
              <h3 className="text-lg font-semibold mb-3">Monthly Plan</h3>
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="monthly-price"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Monthly Price
                  </label>
                  <input
                    type="number"
                    id="monthly-price"
                    value={paymentData.subscription_plans?.monthly?.monthly}
                    onChange={(e) =>
                      updateSubscriptionPlan(
                        "monthly",
                        "monthly",
                        parseFloat(e.target.value)
                      )
                    }
                    min={0}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
                <div>
                  <label
                    htmlFor="monthly-doses"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Number of Doses
                  </label>
                  <input
                    type="number"
                    id="monthly-doses"
                    value={paymentData.subscription_plans?.monthly?.doses}
                    onChange={(e) =>
                      updateSubscriptionPlan(
                        "monthly",
                        "doses",
                        parseInt(e.target.value)
                      )
                    }
                    min={0}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
              </div>
            </div>
          )}

          {/* {selectedPlans.quarterly && (
            <div className="mb-6 p-4 border border-gray-200 rounded-md">
              <h3 className="text-lg font-semibold mb-3">Quarterly Plan</h3>
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="quarterly-monthly-price"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Quarterly Monthly Price
                  </label>
                  <input
                    type="number"
                    id="quarterly-monthly-price"
                    value={paymentData.subscription_plans?.quarterly?.monthly}
                    onChange={(e) =>
                      updateSubscriptionPlan(
                        "quarterly",
                        "monthly",
                        parseFloat(e.target.value)
                      )
                    }
                    min={0}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
                <div>
                  <label
                    htmlFor="quarterly-first-month"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    First Month Payment (Optional)
                  </label>
                  <input
                    type="number"
                    id="quarterly-first-month"
                    value={
                      paymentData.subscription_plans?.quarterly
                        ?.first_month_pay || ""
                    }
                    onChange={(e) =>
                      updateSubscriptionPlan(
                        "quarterly",
                        "first_month_pay",
                        e.target.value ? parseFloat(e.target.value) : null
                      )
                    }
                    min={0}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
                <div>
                  <label
                    htmlFor="quarterly-doses"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Number of Doses
                  </label>
                  <input
                    type="number"
                    id="quarterly-doses"
                    value={paymentData.subscription_plans?.quarterly?.doses}
                    onChange={(e) =>
                      updateSubscriptionPlan(
                        "quarterly",
                        "doses",
                        parseInt(e.target.value)
                      )
                    }
                    min={0}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
              </div>
            </div>
          )} */}
        </>
      )}
      <div className="mb-6 p-4 border border-gray-200 rounded-md">
        <h3 className="text-lg font-semibold mb-3">Discount</h3>
        <div className="space-y-4">
          <div>
            <label
              htmlFor="discount"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Discount %
            </label>
            <input
              type="number"
              id="discount"
              value={paymentData.discount}
              onChange={(e) =>
                setPaymentData((prev) => ({
                  ...prev,
                  discount: 
                    e.target.value > 100
                      ? 100
                      : e.target.value < 0
                      ? 0
                      : e.target.value,
                }))
              }
              min={0}
              max={100}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            />
          </div>
          <div>
            <label
              htmlFor="expires"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Expires
            </label>
            <input
              type="datetime-local"
              id="expires"
              value={paymentData.expires}
              onChange={(e) =>
                setPaymentData((prev) => ({
                  ...prev,
                  expires: e.target.value,
                }))
              }
              min={getMinDate()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            />
          </div>
        </div>
      </div>
      <div className="mb-6 p-4 border border-gray-200 rounded-md">
        <h3 className="text-lg font-semibold mb-3">Coupon</h3>
        <div className="space-y-4">
          <div>
            <label
              htmlFor="coupon-code"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Code
            </label>
            <input
              type="text"
              id="coupon-code"
              value={paymentData.coupon_code}
              onChange={(e) =>
                setPaymentData((prev) => ({
                  ...prev,
                  coupon_code: e.target.value?.replace(/\s+/g, ""),
                }))
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            />
          </div>
          <div>
            <label
              htmlFor="price-percentage"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Price %
            </label>
            <input
              type="number"
              id="price-percentage"
              value={paymentData.coupon_price_percentage}
              onChange={(e) =>
                setPaymentData((prev) => ({
                  ...prev,
                  coupon_price_percentage:
                    e.target.value > 100
                      ? 100
                      : e.target.value < 1
                      ? 1
                      : e.target.value,
                }))
              }
              min={1}
              max={100}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            />
          </div>
          <div>
            <label
              htmlFor="coupon-code-expires"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Expires
            </label>
            <input
              type="datetime-local"
              id="coupon-code-expires"
              value={paymentData.coupon_code_expires}
              onChange={(e) =>
                setPaymentData((prev) => ({
                  ...prev,
                  coupon_code_expires: e.target.value,
                }))
              }
              min={getMinDate()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            />
          </div>
          {paymentData.coupon_code && (
            <button
              className="bg-red-500 text-white px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
              onClick={() =>
                setPaymentData((prev) => ({
                  ...prev,
                  coupon_code: "",
                  coupon_code_expires: "",
                  coupon_price_percentage: '',
                }))
              }
            >
              Remove Coupon
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
